import './index.css';
import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { s as styles } from './progress-bar-CO7jmyT5.js';

const STYLE_TO_CSS = {
    accent: styles.progressStyleAccent,
    positive: styles.progressStylePositive,
    special: styles.progressStyleSpecial,
};
const SingleProgressBar = ({ max = 100, progress, style = 'accent', 'data-qa': dataQA = 'progress', 'aria-label': ariaLabel, }) => {
    const width = (progress / max) * 100;
    return (jsx("div", { className: classnames(styles.progress, STYLE_TO_CSS[style]), role: "progressbar", "aria-valuemin": 0, "aria-valuemax": max, "aria-valuenow": progress, "aria-label": ariaLabel, "data-qa": dataQA, children: jsx("div", { className: styles.progressValue, "data-qa": "progress-value", style: { width: `${width}%` } }) }));
};

export { SingleProgressBar };
//# sourceMappingURL=SingleProgressBar.js.map
